<div class="coverage-plan">
	<div class="title mb-2">Coverage</div>
	<div class="plans d-flex">
		<div class="plan plan--current mr-4">
			<div class="sub-title text-grey mb-2">Current Plan</div>
			<div class="mb-3">
				<span class="mr-1">{{ data?.coverage.currentPlan.SRI | percent | emptyValue }}</span
				>SRI
			</div>
			<div class="mb-3">
				<span class="mr-1">{{ data?.coverage.currentPlan.CRI | percent | emptyValue }}</span
				>CRI
			</div>
			<div>
				<span class="mr-1">{{ data?.coverage.currentPlan.SP | percent | emptyValue }}</span
				>Saving Plans
			</div>
		</div>
		<div class="plan plan--optimal">
			<div class="sub-title d-flex align-items-center mb-2">
				<img
					*ngIf="isZestyDomain"
					alt="Supported"
					class="mr-1"
					height="14"
					ngSrc="/assets/icons/potential-savings/zesty-commitment-supported.svg"
					width="11"
				/>
				Optimal Plan
			</div>
			<div class="mb-1">
				<div class="d-flex align-items-center">
					<div class="input-block d-flex align-items-center">
						<input
							[class.invalid]="!!getFormControl('sri_coverage')?.errors"
							[formControl]="getFormControl('sri_coverage')"
							class="input-block__value"
							type="number"
						/>
						<div class="input-block__symbol">%</div>
					</div>
					<span class="ml-1">SRI</span>
				</div>
			</div>
			<div class="mb-1">
				<div class="d-flex align-items-center">
					<div class="input-block d-flex align-items-center">
						<input
							[class.invalid]="!!getFormControl('cri_coverage')?.errors"
							[formControl]="getFormControl('cri_coverage')"
							class="input-block__value"
							type="number"
						/>
						<div class="input-block__symbol">%</div>
					</div>
					<span class="ml-1">CRI</span>
				</div>
			</div>
			<div class="mb-3">
				<div class="d-flex align-items-center">
					<div class="input-block d-flex align-items-center">
						<input
							[class.invalid]="!!getFormControl('sp_coverage')?.errors"
							[formControl]="getFormControl('sp_coverage')"
							class="input-block__value"
							type="number"
						/>
						<div class="input-block__symbol">%</div>
					</div>
					<span class="ml-1">SP</span>
				</div>
			</div>
			<div>
				<button (click)="applyChanges.emit()" class="btn btn-sm btn-outlined" type="button">
					Apply<span class="icon icon--arrow-right ml-2"></span>
				</button>
			</div>
		</div>
	</div>
</div>
